import React, { memo, useEffect, useState } from 'react';
import LazyImage from '../../CustomLibraries/LazyImage';
import { Swiper, SwiperSlide } from 'swiper/react';

import '../../../assets/sass/uiV3/component/worldcup2023/_worldcup2023.scss';
import { useLeaderboardDetails } from '../../../Queries/QueryHooks/spq.hook';
import { isMobile } from 'react-device-detect';
import doctorText from '../cards/event/worldcup2023assets/Doctor.svg';
import logoWorldCup from '../cards/event/worldcup2023assets/Logo.svg';
import worldcupText from '../cards/event/worldcup2023assets/Worldcup.svg';
import InView, { useInView } from 'react-intersection-observer';
import useRedirect from '../../customHooks/useRedirect';
import { useDispatch } from 'react-redux';
import { postAnalyticsCTA } from '../../../Store/actions';
import { useTrackUserActivity } from '../../customHooks/useTrackUserActivity';
const Leaderboard = ({ winners, logo, title, page_name, page_id, id, ctaId }) => {
  const sponsor_logo = logo ? logo.split(',') : [];
  const [inView, setInView] = useState(false);

  const { redirectTo } = useRedirect();
  const dispatch = useDispatch();
  const reportCtaClick = () => {
    console.log('user has clicked a cta');
    let postObj = {
      cta_type: 'leaderboard',
      cta_type_id: id,
      target_type: page_name,
      target_type_id: page_id,
      position: 'top',
      cta_id: ctaId
    };
    dispatch(postAnalyticsCTA(postObj, () => {}));
  };
  function handleClick() {
    reportCtaClick();
    if (page_name !== 'channel') {
      redirectTo('channelProfile', 82);
    }
  }
  const { userActivityTracker } = useTrackUserActivity();

  function handleChange(inView) {
    if (inView) {
      setInView(inView);
    }
    userActivityTracker(inView, { type: 'leaderboard', type_id: id }, 'cta', page_id);
  }

  return (
    <InView
      as="div"
      className={`rounded-3 position-relative overflow-hidden worlcup2023Leaderboard ${
        page_name !== 'channel' ? 'cursorPointer' : ''
      } ${inView ? 'worldcup2023__animation--start' : ''}`}
      onChange={(inView) => handleChange(inView)}
      onClick={handleClick}
    >
      <div className="worldcup2023PollCard__animation d-flex align-items-center justify-content-center  position-absolute top-0 start-0 w-100 bg-white">
        <div className="overlay"></div>
        <div className="position-relative worldcup2023PollCard__container z-1">
          <img src={logoWorldCup} alt="logo" className="worldcup2023PollCard__logo" />
          <div className="d-flex align-items-start justify-content-center flex-column gap-3 worldcup2023PollCard__animation__Text">
            <img src={doctorText} alt="logo" className="worldcup2023PollCard__doctorText" />
            <img src={worldcupText} alt="logo" className="worldcup2023PollCard__worldcupText" />
          </div>
        </div>
      </div>
      <div className="worldcup2023__animation__contentMain d-flex flex-column gap-3 worlcup2023Table rounded-3 position-relative overflow-hidden z-2">
        <div className="overlay">
          <img
            src="https://storage.googleapis.com/medwiki/common/worldcupTableBg.png"
            alt="background"
            className="w-100 h-100 object-fit-cover"
          />
        </div>
        <div
          className="d-flex flex-column z-2 position-relative"
          title={`${page_name !== 'channel' ? 'Click To Know More' : ''}`}
        >
          <div className="d-flex align-items-center justify-content-between ps-3 ps-sm-4">
            <h2 className="fs-1 fw-semibold text-white py-3">{title}</h2>
            <div className="worlcup2023Table__clr_v3_sponsor_prrnt position-relative">
              {sponsor_logo && sponsor_logo.length > 0 && (
                <Swiper
                  className="clr_v3_sponsor text-center me-0 bg-white z-2 position-relative py-2 px-3"
                  navigation={false}
                  spaceBetween={0}
                  slidesPerView={1}
                  loop={true}
                  autoplay={{
                    delay: 2500
                  }}
                  effect={'fade'}
                >
                  {sponsor_logo.map((_elem, idx) => (
                    <SwiperSlide
                      key={idx + 1}
                      className="clr_v3_sponsor_slide w-100 position-relative"
                    >
                      <LazyImage
                        src={_elem}
                        alt="sponsor"
                        className={`mw-100 mh-100 position-absolute translate-middle start-50 top-50`}
                        logo
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              )}
            </div>
          </div>
          <div className="d-flex flex-column p-sm-4 p-3 pt-3 gap-4 justify-content-center worlcup2023Table__main">
            {/* 1st - 3rd */}
            <div className="row justify-content-center row-gap-3">
              {/* item */}
              {winners &&
                winners.length > 0 &&
                [...winners].slice(0, 3).map((item, index) => (
                  <div className="col-md-4 col-12" key={item.user_master_id}>
                    <div className="bg-white rounded-3 d-flex align-items-center gap-3 worlcup2023Table__items worlcup2023Table__items--Big overflow-hidden">
                      <div className="position-relative ps-2 d-inline-flex align-items-center justify-content-center flex-shrink-0 h-100 worlcup2023Table__items__rank"></div>
                      <div className="d-flex flex-column-reverse py-3 pe-3 gap-2 flex-grow-1">
                        <h4
                          className={`text-black fw-medium line-clamp-1 worlcup2023Table__ttl fs-16`}
                        >
                          Dr.{' '}
                          {item?.first_name?.charAt(0).toUpperCase() +
                            item?.first_name?.slice(1).toLowerCase()}{' '}
                          {item?.last_name?.charAt(0).toUpperCase() +
                            item?.last_name?.slice(1).toLowerCase()}
                        </h4>
                        <div className="d-flex justify-content-between align-items-end">
                          <span className="fs-1 fw-semibold flex-shrink-0 worlcup2023Table__items__points_1">
                            {item.points}
                          </span>
                          {!isMobile && (
                            <span className="flex-shrink-0">
                              <img
                                src={
                                  item.rank === 1
                                    ? 'https://storage.googleapis.com/medwiki/common/FirstCrown.svg'
                                    : item.rank === 2
                                    ? 'https://storage.googleapis.com/medwiki/common/SecondCrown.svg'
                                    : 'https://storage.googleapis.com/medwiki/common/ThirdCrown.svg'
                                }
                                alt="badge"
                                className="icon-size-60"
                              />
                            </span>
                          )}
                        </div>
                      </div>
                      {isMobile && (
                        <span className="flex-shrink-0 d-flex align-items-center">
                          <img
                            src={
                              item.rank === 1
                                ? 'https://storage.googleapis.com/medwiki/common/FirstCrown.svg'
                                : item.rank === 2
                                ? 'https://storage.googleapis.com/medwiki/common/SecondCrown.svg'
                                : 'https://storage.googleapis.com/medwiki/common/ThirdCrown.svg'
                            }
                            alt="badge"
                            className="icon-size-80"
                          />
                        </span>
                      )}
                    </div>
                  </div>
                ))}
            </div>

            {/* 4th - 10th */}
            <div className="row row-gap-3 justify-content-center">
              {winners &&
                winners.length > 3 &&
                [...winners].slice(3, 10).map((item, index) => (
                  <>
                    {/* item */}
                    <div className="col-sm-6 col-12">
                      <div className="bg-white rounded-3 d-flex p-0 gap-3 worlcup2023Table__items overflow-hidden">
                        <div className="position-relative ps-3 d-inline-flex align-items-center justify-content-center flex-shrink-0 worlcup2023Table__items__rank">
                          <span className="position-relative z-2 fs-2 fw-semibold text-white">
                            {index + 4}
                            <sup>th</sup>
                          </span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center py-3 pe-3 gap-2 flex-grow-1">
                          <h4 className="fs-16 text-black fw-medium line-clamp-1 worlcup2023Table__ttl">
                            Dr.{' '}
                            {item?.first_name?.charAt(0).toUpperCase() +
                              item?.first_name?.slice(1).toLowerCase()}{' '}
                            {item?.last_name?.charAt(0).toUpperCase() +
                              item?.last_name?.slice(1).toLowerCase()}
                          </h4>
                          <span className="fs-2 fw-semibold  flex-shrink-0 worlcup2023Table__items__points_1">
                            {item.points}
                          </span>
                        </div>
                      </div>
                    </div>
                    {/* item end*/}
                  </>
                ))}
              {/* item end */}
            </div>
          </div>
        </div>
      </div>
    </InView>
  );
};
const LeaderboardCta = ({ id = 0, logo, page_name, page_id, ctaId, ctaType }) => {
  const { data: leaderBoardData } = useLeaderboardDetails(id, (res) =>
    console.log('leader board response here:', res)
  );
  return (
    <>
      {leaderBoardData?.winners && leaderBoardData?.winners?.length > 0 && (
        <Leaderboard
          winners={leaderBoardData.winners}
          logo={logo}
          title={leaderBoardData?.details?.title}
          page_name={page_name}
          page_id={page_id}
          ctaId={ctaId}
          id={id}
        />
      )}
    </>
  );
};

export default memo(LeaderboardCta);
